/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import ReactPaginate from 'react-paginate';

import { PastTransaction } from '../../actions/ecomm-interfaces';

import { IEcommHistoryListViewProps } from './ecomm-history-list';

import { HistoryCard } from './component/ecomm-history-card'

/**
 *
 * EcommHistoryListView component
 * @extends {React.PureComponent<IEcommHistoryListViewProps>}
 */
export class EcommHistoryListView extends React.PureComponent<IEcommHistoryListViewProps> {
  public state: any = { selectedCategory: 0, style: '', width: 0, hasMounted: false, activePage: 0, pageSize: 10 };

  private module = 'ecomm-history-list-container';

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      window.addEventListener('resize', this._updateDimensions);

      this.setState({ style: this.module, width: window.innerWidth, hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const { filteredCategory, orderHistory } = this.props;

    let offset = this.state.activePage * Number(this.state.pageSize);

    if (this.state.selectedCategory !== filteredCategory) {
      offset = 0;

      this.setState({ selectedCategory: filteredCategory, activePage: 0 });
    }
    
    const totalPageData = orderHistory.length > 0 ? orderHistory.filter(history => Number(history.Record.ProductCategoryID) == filteredCategory) : [];

    const currentPageData = totalPageData.length > 0 ? totalPageData.slice(offset, offset + Number(this.state.pageSize)).map((order: PastTransaction) => <HistoryCard
      TransactionInfo={order}
      OrderDateTitle={this.props.config.orderDateText ? this.props.config.orderDateText : ''}
      ReceiptTitle={this.props.config.receiptsText ? this.props.config.receiptsText : ''}
      SerialNumberText={this.props.config.serialNumberText ? this.props.config.serialNumberText : ''}
      Width={this.state.width}
      Locale={this.props.context.request.locale.split("-")[0]}
    />) : [];

    const pageCount = Math.ceil(totalPageData.length / this.state.pageSize);

    return (
      <div className={this.state.style}>
        <ul className='ecomm-history-list'>{currentPageData}</ul>
        {pageCount > 0 && <ReactPaginate
          previousLabel={'<'}
          nextLabel={'>'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this._handlePageClick}
          containerClassName={'ecomm-pagination'}
          activeClassName={'active'}
          forcePage={this.state.activePage}
        />}
      </div>
    );
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  private _handlePageClick = (data: any) => {
    if (window) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    this.setState({ activePage: data.selected });
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
}

export default EcommHistoryListView;